import React, { Component } from 'react'
import { injectIntl } from 'react-intl'

import { Layout, Content, Container, PageTitle } from 'src/components/Layout'
import List from 'src/components/List'
import { Loader } from 'src/components/Loader'
import intlMessages from './translations'
import intlMessagesClaim from '../translations'

class Drivers extends Component {
  componentDidMount() {
    this.props.getDrivers()
  }

  getDriversList = (drivers = []) => {
    const { intl } = this.props

    return [
      ...drivers.reduce((result, driver) => {
        return [
          ...result,
          {
            leftIcon: ['far', 'steering-wheel'],
            name: `${driver.firstName} ${driver.lastName}`,
            url: '/claims/form',
            rightIcon: 'right',
            type: 'person',
            driver,
            hideArrow: true,
            hideArrowOnMobile: true,
          },
        ]
      }, []),
      {
        leftIcon: ['far', 'circle-parking'],
        type: 'noDriver',
        name: intl.formatMessage(intlMessages.driversNoDriver),
        driver: null,
        url: '/claims/form',
        rightIcon: 'right',
        hideArrow: true,
        hideArrowOnMobile: true,
      },
      {
        leftIcon: ['far', 'user-plus'],
        type: 'AddPerson',
        name: intl.formatMessage(intlMessages.driversSomeoneElse),
        url: '/claims/drivers/new',
        rightIcon: 'right',
        hideArrow: true,
        hideArrowOnMobile: true,
      },
    ]
  }

  handleClick = item => {
    if (item.type !== 'addPerson') {
      this.props.setDriver(item.driver || null)
    }
  }

  render() {
    const { drivers, loading, intl } = this.props

    return (
      <Layout className='m-claims-drivers claims-list'>
        <Content>
          <PageTitle
            title={intl.formatMessage(intlMessages.driversHeadline)}
            subtitle={intl.formatMessage(intlMessagesClaim.claimsFillOutTheForm)}
          />
          <Container>
            {loading ? (
              <Loader styleVariation='staticWithHeight' />
            ) : (
              <List
                isColumn={true}
                items={this.getDriversList(drivers)}
                onClick={this.handleClick}
                noMargin={true}
              />
            )}
          </Container>
        </Content>
      </Layout>
    )
  }
}

export default injectIntl(Drivers)
